import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'filterText'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchtext: string, type = 'fullName'): any[] {
  if(!items) return [];
  if(!searchtext) return items;
  searchtext = searchtext.toLowerCase();
  return items.filter( it => {
  return it[type].toLowerCase().includes(searchtext);
  });
  }
}
